import React from 'react';
import { SmoothScroll } from '../components/SmoothScroll';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Services } from '../components/Services';
import { Process } from '../components/Process';
import { IndustriesEngagement } from '../components/IndustriesEngagement';
import { TechBenefits } from '../components/TechBenefits';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';

export default function HomePage() {
  return (
    <SmoothScroll>
      <div className="App bg-[#0f0f10] min-h-screen">
        <Header />
        <Hero />
        <About />
        <Services />
        <Process />
        <IndustriesEngagement />
        <TechBenefits />
        <Contact />
        <Footer />
      </div>
    </SmoothScroll>
  );
}
